import React, { useEffect, useState } from 'react';
import useSWR from 'swr';
import { css } from '@emotion/react';
import { Navigate } from 'react-router-dom';

import { SwButtonSection, getFetcher, ADMIN_ACCESS_TOKEN_KEY, PRODUCT_TITLE } from '../../../App';
import { Divider } from '@components/atoms';
import { Body, dialogContentsState, MailSettingField } from '@components/templates';
import PrimaryButton from '@components/atoms/Inputs/Button/Primary';
import { icons } from '@assets/icons';
import { ErrorCode, ErrorMessage } from '@variables/error';
import { SetterOrUpdater, useSetRecoilState } from 'recoil';
import { DialogProps } from '@components/templates/Dialog';
import { MailSettingsBody, MailIcon } from './style';
import { submitDebounce } from '../../../utils/lib';

const MailSettingPage = () => {
  const [accessToken, setAccessToken] = useState('');
  const [settingFields, setSettingFields] = useState<any>({});
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const setDialogContents = useSetRecoilState(dialogContentsState);

  useEffect(() => {
    const newToken = localStorage.getItem(ADMIN_ACCESS_TOKEN_KEY);
    if (newToken) {
      setAccessToken(newToken);
    }
  }, []);

  const url = `api/sw/email`;
  const { data, error } = useSWR(!!accessToken.length ? [{ url, accessToken }] : null);

  useEffect(() => {
    if (data?.result) {
      setSettingFields({
        ...data.result,
        userPassword: '',
      });
    }
  }, [data]);

  if (error) {
    return <div>failed to load</div>;
  }
  if (data) {
    if (data.code === 'UNAUTHORIZED') return <Navigate to={'/'} replace={true} />;
  }

  const onChangeSettingField = (e: any) => {
    const list = { ...settingFields };
    list[e.target.name] = e.target.value;
    setSettingFields(list);
    setIsSubmitDisabled(!checkValidation(list));
  };

  const submitClick = async () => {
    await onSubmit(settingFields, accessToken, setDialogContents);
  };
  const onSubmit = async (fields: any, token: string, setDialog: SetterOrUpdater<DialogProps>) => {
    const response = await getFetcher({
      method: 'PUT',
      accessToken: token,
      body: {
        ...fields,
      },
    })(`api/sw/email`);

    if (response.code !== '200') {
      let header = '';
      let body = '';
      if (ErrorCode[response.code]) {
        header = `${ErrorCode[response.code]}`;
        body = `${ErrorMessage[ErrorCode[response.code]]}`;
      } else {
        header = response.code;
      }

      setDialog({
        type: 'error',
        header: `${header}`,
        body: <>{body}</>,
        footer: <PrimaryButton onClick={() => setDialog({ type: 'hidden' })}>OK</PrimaryButton>,
      });
    }
  };

  const checkValidation = (fields: any) => {
    const { fromAddress, fromName, host, port, userName, userPassword } = fields;
    return fromAddress && fromName && host && port && userName && userPassword;
  };

  return (
    <>
      <label>Mail(SMTP) Setting</label>
      <MailSettingsBody>
        <MailIcon>
          <img src={icons.email} />
        </MailIcon>
        <Divider data-orientation="vertical" />
        <MailSettingField onChange={onChangeSettingField} {...settingFields} accessToken={accessToken} />
      </MailSettingsBody>
      <SwButtonSection>
        <PrimaryButton
          styles={css`
            width: 145px;
            height: 48px;
            font-size: 18px;
          `}
          onClick={submitDebounce(submitClick)}
          disabled={isSubmitDisabled}
        >
          Submit
        </PrimaryButton>
      </SwButtonSection>
    </>
  );
};

export default MailSettingPage;
